import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { ISyncDataFeature } from './sync-data.feature.state';
import { SyncDataState } from './sync-data.state';

export const getSyncDataState: MemoizedSelector<ISyncDataFeature, SyncDataState> = createFeatureSelector<SyncDataState>(
  nameof<ISyncDataFeature>('syncDataFeature')
);

export const getIsLoading = createSelector(getSyncDataState, (state: SyncDataState) => state.isLoading);

export const getFailures = createSelector(getSyncDataState, (state: SyncDataState) => state.failures);
